enum PlatformCoreUserFilterQueryMode {
    NONE = 'NONE',
    JUMP_TO_MEMBER = 'JUMP_TO_MEMBER',
}

export default PlatformCoreUserFilterQueryMode;
